import { Media } from "@/interfaces/media";
import axios from "@/lib/axios";
import { useMutation, useQuery } from "@tanstack/vue-query";
import { useTemplateRefsList } from "@vueuse/core";
import { ToastInterface, useToast } from "vue-toastification";

interface Props {
  immediate?: boolean;
  params?: Params;
}

interface Params {
  id: number | string;
}

interface CreateMediaParams {
  id: number | string;
  media: File;
  collection: string;
  expirationDate: string;
}

const getHotelMedia = async (params: Params): Promise<Media[]> => {
  const { data } = await axios.get(`/api/internal/hotels/${params.id}/medias`);

  return data;
};

const createMediaHotel = async (
  params: CreateMediaParams,
  toast: ToastInterface,
) => {
  try {
    const formData = new FormData();
    formData.append("media", params.media);
    formData.append("collection", params.collection);
    formData.append("expiration_date", params.expirationDate);

    const { data } = await axios.post(
      `/api/internal/hotels/${params.id}/medias`,
      formData,
    );

    toast.success("Subida correctamente");
    return data;
  } catch (error: any) {
    toast.error(error.response.data.message);
  }
};

const useHotelMedia = (props: Props) => {
  const toast = useToast();

  const { data, isLoading, refetch } = useQuery(
    ["hotel-media", props.params],
    () =>
      getHotelMedia({
        id: props.params?.id!,
      }),
    {
      enabled: props.immediate,
    },
  );

  const createMediaHotelMutation = useMutation((params: CreateMediaParams) =>
    createMediaHotel(params, toast),
  );

  return {
    data,
    isLoading,
    refetch,

    createMediaHotelMutation: createMediaHotelMutation.mutate,
    createMediaHotelAsyncMutation: createMediaHotelMutation.mutateAsync,
    createMediaHotelLoading: createMediaHotelMutation.isLoading,
    createMediaHotelError: createMediaHotelMutation.error,
  };
};

export default useHotelMedia;
